import React, { useState } from "react";
import { Link } from "react-router-dom";
import ViewRom from "./ViewRom";
import ViewStrength from "./ViewStrength";
import ViewIsokinetic from "./ViewIsokinetic";
import ViewSpecial from "./ViewSpecial";

const ViewAsmntTabs = ({ dta }: { dta: any }) => {
   const [activeTab, setActiveTab] = useState("Range of Motion");

    const tabData = [
        {
            icon: <i className="fas fa-globe" />,
            name: "Range of Motion",
            content: <ViewRom stepData={dta} />
        },
        {
            icon: <i className="fas fa-globe" />,
            name: "Strength",
            content: <ViewStrength stepData={dta} />
        },
        {
            icon: <i className="fas fa-globe" />,
            name: "Isokinetic",
            content: <ViewIsokinetic stepData={dta} />
        },
        {
            icon: <i className="fas fa-globe" />,
            name: "Special Tests",
            content: <ViewSpecial stepData={dta} />
        }
    ]
    return (
        <>
            <div className="container" style={{ maxWidth: "1380px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                        onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewAsmntTabs;